import { FC } from 'react';

import { Card } from '@/components/atoms';
import { CardContent } from '@/components/atoms/Card/Card';
import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { CATEGORY_CARD_TEST_IDS } from '@/constants/data-testids';

export const CategoryCardSkeleton: FC = () => {
  return (
    <Card data-testid={CATEGORY_CARD_TEST_IDS.SKELETON} className="rounded-[12px] p-4">
      <CardContent className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <Skeleton className="size-[52px] rounded-[8px]" />
          <div className="flex flex-col gap-1 w-full">
            <Skeleton className="h-[14px] w-1/2" />
            <Skeleton className="h-[14px] w-1/5" />
          </div>
        </div>
        <div className="h-[105px] flex flex-col gap-4">
          {Array.from({ length: 3 }, (_, index) => (
            <Skeleton key={index} className="w-full h-[14px]" />
          ))}
        </div>
        <Skeleton className="h-[14px] w-2/5" />
      </CardContent>
    </Card>
  );
};
